import type { ParsedUrlQuery } from 'querystring';

export const toClassDetailsProps = (query: ParsedUrlQuery): ClassDetailsProps => {
  const classId = query?.classId ?? undefined;
  return { classId };
};

export const toTagDetailsProps = (query: ParsedUrlQuery): TagDetailsProps => {
  const tagName = query?.tagName ?? undefined;
  return { tagName };
};

export const toScheduleEventDetailsProps = (
  query: ParsedUrlQuery,
): ScheduleEventDetailsProps => {
  const classId = query?.classId ?? undefined;
  const start = query?.start ?? undefined;
  const type = query?.type ?? undefined;
  return { classId, start, type };
};

export const toDetailedWorkoutDetailsProps = (
  query: ParsedUrlQuery,
): DetailedWorkoutsDetailsProps => {
  const shareWorkoutId = query?.shareWorkoutId ?? undefined;
  return { shareWorkoutId };
};

export const toInviteDetailsProps = (query: ParsedUrlQuery): InviteDetailsProps => {
  const inviteId = query?.inviteId ?? undefined;
  return { inviteId };
};

export const toGenericWorkoutProps = (query: ParsedUrlQuery) => {
  const workoutId = query?.workoutId ?? undefined;
  return { workoutId };
};
